
export class WorksheetBaseModel {
   parent: WorksheetBaseModel;
   children: Array<WorksheetBaseModel>;


  constructor(options: {
    parent?: WorksheetBaseModel
  } = {}) {
    this.parent = options.parent;
    this.children = new Array();
  }
}
